export const ERROR_TYPES = ['TypeError', 'ApolloError']
export const GENERIC_ERROR_TYPES = ['TypeError']
export const AUTH_CODES = ['401', '400']
export const SOURCE_CART = 'HELICARRIER'
export const ERROR_BY_FETCH = 'Failed to fetch'

export const CHUNK_LIST = [
  'chunks/node_modules',
  'chunks/webpack',
  'chunks/vendor',
  'chunks/',
]
export const ADS_LIST = [
  'pagead',
  'ads',
  'ad',
  'adsbygoogle',
  'googlesyndication',
  'doubleclick',
  'googleads',
  'googlead',
  'googletag',
  'gpt',
  'admanager',
  'advertising',
  'adserver',
  'advertising',
  'adtech',
  'adnxs',
  'adform',
  'adroll',
  'adblade',
  'adzerk',
  'admeld',
  'adap',
  'tag/js/gpt',
]
